import { Theme } from '@mui/material/styles'

const muiMenu = (theme: Theme) => {
  return {
    styleOverrides: {
      paper: {
        border: `1px solid ${theme.colors.stroke}`,
        borderRadius: 12
      },
      root: {
        overflow: 'hidden'
      },
      list: {
        padding: 0
      }
    }
  }
}

export default muiMenu
